import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

import justLogo from '../images/justlogo500.png';
import greenCheck from '../images/check-green.png';
import exchangeArrows from '../images/double-arrow.png';

import UserSquare from '../components/UserSquare.jsx';
import LoaderModal from '../components/LoaderModal.jsx';
import BackLinkButton from '../components/BackLinkButton';

const ConfirmExchange = () => {

    const { objectId, token } = useParams();

    const [isFetchPending, setIsFetchPending] = useState(false);
    const [exchange, setExchange] = useState(null);

    //----- CHIAMATA ALLA COLLECTION EXCHANGE PER RICEVERE TUTTI I DATI DELLO SCAMBIO -----//

    const getExchangeData = async () => {

        setIsFetchPending(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/exchanges/pickedObject/${objectId}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const exchangeData = await response.json();
                setExchange(exchangeData.payload);
            } else {
                console.log('Errore nella richiesta.', response);
            }
        } catch (error) {
            console.log('Error Type: ', error);
        }

    }

    useEffect(() => {
        getExchangeData();
    }, [])

    useEffect(() => {
        setIsFetchPending(false);
        console.log('exchange: ', exchange);
    }, [exchange])

    //-----//

    //----- GESTIONE DEL TASTO DI CONFERMA DEFINITIVA -----//

    const [isPressing, setIsPressing] = useState(false);
    const [countdown, setCountdown] = useState(5);

    const pressTimer = useRef();

    const handleOnMouseDown = () => {
        setIsPressing(true);
        setCountdown(5);
        pressTimer.current = setInterval(() => {
            setCountdown(prevCountdown => {
                if (prevCountdown <= 1) {
                    clearInterval(pressTimer.current);
                    setIsPressing(false);
                    sendDonateRequest();
                    return 5;
                } else {
                    return prevCountdown - 1;
                }
            });
        }, 1000);
    }

    const handleOnMouseUp = () => {
        setIsPressing(false);
        clearInterval(pressTimer.current);
        setCountdown(5);
    }

    const [donated, setDonated] = useState(false);
    const [wrongDonateFetch, setWrongDonateFetch] = useState(false)

        //----- CHIAMATA FINALE PER CONFERMARE LA RICHIESTA -----//

        const sendDonateRequest = async () => {
            setIsFetchPending(true);
            try {
                const res = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/exchanges/donateObject/${exchange.robaObject._id}/${exchange.taker._id}`, {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                })

                if (res.ok) {
                    const donatedObject = await res.json();
                    setDonated(true);
                } else {
                    setWrongDonateFetch(true);
                    console.log('Errore. ', res)
                }
            } catch (error) {
                setWrongDonateFetch(true);
                console.log('Error Type: ', error)
            }
            setIsFetchPending(false);
        }

        //-----//

    //-----//

    return (
        <div className="container">
            <img src={justLogo} style={{ width: '50px' }} />
            <BackLinkButton />
            <h2>CONFERMA DEFINITIVA</h2>
            {exchange && (

                <div className="border-box">
                    <UserSquare user={{
                        id: exchange.supplier._id,
                        avatar: exchange.supplier.avatar.url,
                        name: exchange.supplier.name,
                        surname: exchange.supplier.surname,
                        address: exchange.supplier.position.address
                    }} />
                    <h3>Controlla lo score!!!</h3>

                    <div className="border-box-confirm-request">

                        {!donated && <div className="exchange-arrows"><img src={exchangeArrows} /></div>}
                        {!donated && <div className="exchange-arrows"><img src={exchangeArrows} /></div>}

                    {!donated &&
                        <div>
                            <h3>Per confermare definitivamente lo scambio, TIENI PREMUTO per </h3>
                            <span className="countdown">{countdown}</span>
                            <h3>secondi sull'oggetto:</h3>
                        </div>
                    }

                    {donated && <h1>Complimenti! Potete scambiarvi l'oggetto!</h1>}

                    <div
                        className={donated ? 'object-round-icon round-green' : (isPressing ? 'object-round-icon round-yellow' : 'object-round-icon')}
                        onMouseDown={handleOnMouseDown}
                        onMouseUp={handleOnMouseUp}
                        onMouseLeave={handleOnMouseUp}
                    >
                        {donated && <div className='confirmed-round-icon'>
                            <img src={greenCheck} />
                        </div>}

                        <img src={exchange.robaObject.photo.url} />
                    </div>

                    {donated && <h3>Vi è appena stata inviata un'email coi vostri dati per mettervi in contatto. Grazie!</h3>}

                    {wrongDonateFetch && <h2>Qualcosa è andato storto, ricarica la pagina e riprova.</h2>}

                    </div>

                    <UserSquare user={{
                        id: exchange.taker._id,
                        avatar: exchange.taker.avatar.url,
                        name: exchange.taker.name,
                        surname: exchange.taker.surname,
                        address: exchange.taker.position.address
                    }} />
                </div>
            )}
            {isFetchPending && <LoaderModal isFetchPending={isFetchPending} />}
        </div>
    )
}

export default ConfirmExchange;